module.exports = __webpack_public_path__ + "static/media/iPhone.e6cd408c.png";